
<template>
  <v-container
    fill-height
    justify-content-start
    :class="{ 'section-width': lgAndUp }"
    class="pa-0"
  >
    <v-layout v-if="activities.extendedActivity" column>
      <div class="activity-header">
        <div class="activity-title" :class="{ 'pl-0': xsOnly }">
          <v-icon @click="exit()" color="white" class="ms-3 me-3">mdi-arrow-left</v-icon>
          <v-toolbar-title>{{ category ? category.category.name : null }}</v-toolbar-title>
        </div>
        <v-img :set="url = categoryCoverImageUrl || coverImageUrl" :lazy-src="url" :src="url" />
      </div>
      <reservation-type-chip :reservationMethodType="reservationMethod.type" />
      <v-layout v-if="category" class="app-scroll-section">
        <v-flex class="app-scroll-section">
          <v-layout column class="full-height py-2">
            <div v-if="category.category.description" class="pa-3 grey--text text--darken-3 pre-wrap" style="font-size: 16px;">{{ category.category.description }}</div>
            <v-layout v-if="catalog" column>
              <div
                v-for="(product, index) in category.products"
                :key="index"
                @click="!state.loading && !product.product.outOfStock ? openProductSelection(product.product) : ''"
                :class="!state.loading && !product.product.outOfStock ? 'clickable' : null"
              >
                <product-list-item v-if="product.product.active" :product="product" />
              </div>
            </v-layout>
            <v-layout v-else justify-center align-center>
              <v-progress-circular indeterminate />
            </v-layout>
          </v-layout>
        </v-flex>
        <v-divider v-if="$vuetify.breakpoint.mdAndUp" vertical />
        <v-flex
          v-if="$vuetify.breakpoint.mdAndUp"
          md5
          class="full-height py-4"
        >
          <summary-data :isComponent="true"/>
        </v-flex>
      </v-layout>
      <v-layout v-else justify-center align-center class="full-height">
        <v-progress-circular indeterminate />
      </v-layout>
      <v-spacer />
      <div class="pa-3" v-if="smAndDown && category">
        <summary-button-wrapper :goToRoute="routeNames.reservationSummary.name" />
      </div>
    </v-layout>
    <v-layout v-else justify-center align-center>
      <v-progress-circular indeterminate />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'

import reservationMixins from '@/mixins/Reservation'
import routeNames from '@/router/routes'
import router from '@/router'
import store from '@/store'

export default {
  beforeRouteEnter (to, from, next) {
    if (store.getters['activityReservations/isUnsaved'] && localStorage.getItem('reservationMethodType')) {
      next()
    } else {
      router.go(-1)
    }
  },
  created () {
    this.$store.dispatch('pages/get', { id: this.$route.params.pageId }).then((page) => {
      const activityId = page.pageSpecific.activityId
      const promises = []
      if (!this.catalog) {
        promises.push(
          this.$store.dispatch('activities/getCatalog', { id: activityId })
            .then(() => {
              this.category = this.categoryById(
                this.$route.params.catalogCategoryId
              )
            })
        )
      } else {
        this.category = this.categoryById(this.$route.params.catalogCategoryId)
      }
      promises.push(this.$store.dispatch('activities/getActivity', { id: activityId }))
      Promise.all(promises).catch(() => {})
    })
  },
  data () {
    return {
      routeNames,
      category: null,
    }
  },
  methods: {
    exit () {
      this.$router.go(-1)
    },
    openProductSelection (product) {
      this.$router.push({
        name: routeNames.catalogProductSelection.name,
        params: { productId: product.id },
      })
      this.$store.commit('cart/setSelectedProduct', product)
    },
  },
  computed: {
    ...mapGetters({
      categoryById: 'activities/categoryById',
      coverImageUrl: 'pages/coverImageUrl',
    }),
    ...mapState({
      cartProducts: (state) => state.cart.cartProducts,
      state: (state) => state.state,
      activities: (state) => state.activities,
      catalog: (state) => state.activities.catalog,
    }),
    categoryCoverImageUrl () {
      return this.category ? this.category.category.coverImageUrl : null
    },
  },
  components: {
    ProductListItem: () => import('@/components/view-components/catalog/ProductListItem.vue'),
    SummaryButtonWrapper: () => import('@/components/view-components/catalog/SummaryButtonWrapper.vue'),
    ReservationTypeChip: () => import('@/components/view-components/reservations/ReservationTypeChip.vue'),
    SummaryData: () => import('@/components/view-components/catalog/Summary.vue'),

  },
  mixins: [
    reservationMixins,
    vuetifyMixins,
  ],
}
</script>

<style lang="scss" scoped>
.product-name {
  font-weight: bold;
  color: grey;
  font-size: 18px;
}
.product-description {
  color: grey;
  font-size: 16px;
}
.activity-header {
  max-width: 100%;
  min-height: 90px;
  max-height: 90px;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  & .activity-title {
    position: absolute;
    z-index: 1;
    top: 8px;
  }
}
</style>
